module.exports = __webpack_public_path__ + "static/media/VestasSans-Light.19dc493f.svg";